var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "ph-host" }, [
    _c("div", { staticClass: "m-wrap" }, [
      _c("div", { staticClass: "m-hero" }, [
        _c("img", { staticClass: "m-bg", attrs: { src: _vm.bgSrc, alt: "" } }),
        _c("div", { staticClass: "m-title" }, [
          _c("div", { staticClass: "m-title__line1" }, [
            _vm._v(_vm._s(_vm.$t("Philippines Cockfighting"))),
          ]),
          _c("div", { staticClass: "m-title__line2" }, [
            _vm._v(_vm._s(_vm.$t("Challenge Rules"))),
          ]),
        ]),
        _c("div", { staticClass: "m-hero-label m-hero-label--left" }, [
          _vm._v(_vm._s(_vm.$t("Banker / Meron"))),
        ]),
        _c("div", { staticClass: "m-hero-label m-hero-label--right" }, [
          _vm._v(_vm._s(_vm.$t("Player / Wala"))),
        ]),
      ]),
      _c("div", { staticClass: "m-card" }, [
        _c("div", { staticClass: "m-card__title" }, [
          _vm._v(_vm._s(_vm.$t("Draw / No Winner"))),
        ]),
        _c("div", { staticClass: "m-card__subtitle" }, [
          _vm._v(_vm._s(_vm.$t("A match is declared DRAW (NO WINNER) if:"))),
        ]),
        _c("div", { staticClass: "m-card__grid" }, [
          _c("img", {
            staticClass: "m-left-art",
            attrs: { src: _vm.leftArtSrc, alt: "" },
          }),
          _c("div", { staticClass: "m-bulletrow" }, [
            _c("img", {
              staticClass: "m-bullet",
              attrs: { src: _vm.checkBulletSrc, alt: "" },
            }),
            _c("span", { staticClass: "m-list__text" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "During the Carreo Procedure (3 UP & 3 DOWN), neither rooster lands two (2) successful pecks, or"
                    )
                  ) +
                  " "
              ),
            ]),
          ]),
          _c("img", {
            staticClass: "m-timer",
            attrs: { src: _vm.timerSrc, alt: "" },
          }),
          _c("div", { staticClass: "m-bulletrow" }, [
            _c("img", {
              staticClass: "m-bullet",
              attrs: { src: _vm.checkBulletSrc, alt: "" },
            }),
            _c("span", { staticClass: "m-list__text" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t(
                      "No winner is declared within 10 minutes from the first contact."
                    )
                  ) +
                  " "
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "m-footnote" }, [
          _vm._v(_vm._s(_vm.$t("*Arena Judge decision is final."))),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }